/* Filtrous "Frequently bought together" + PDP section order - v1.1, 2026-09-02 (Adelaide)

   Rebuilds the lower PDP to the Amazon shape:
     [ Specifications | Description ] tabs   (specs first)
     Frequently bought together              (this file)
     Products related to this item           (this file)
     How these compare                       (filtrous-pdp-compare.js)
     Recommended For You                     (filtrous-pdp-merch.js)
     Recently viewed                         (filtrous-recently-viewed.js)
   and retires "Complete The Protocol", which this block replaces.

   v1.1 (Adelaide): "Products related to this item" and "Recommended For You"
   TRADE PLACES - related now sits directly under the FBT block and the
   personalised rail moves below it - and the family comparison table slots in
   between them at order 4. This file still owns the whole sequence (the CSS
   `order` block below); .fv3-cmp is built by filtrous-pdp-compare.js, and if
   that asset is removed its order number simply goes unused.

   WHERE THE PAIRS COME FROM. Boost AI Search & Discovery was the intended
   source and cannot serve it: every recommendation endpoint 404s for this
   shop (/bc-sf-filter/recommendation/*, /product/recommendation, also_bought,
   relate, bundle) and the `bundles` array on /bc-sf-filter/search comes back
   empty - the search/filter API is live but the recommendation product is not
   enabled. Shopify's own intent=complementary is empty too, because nobody
   has curated complementary products in Search & Discovery.

   So BT_RAW below is mined from REAL ORDERS - a bulk export of 8,562 orders
   (2024-08-01 onward), 3,960 of which contain two or more catalog SKUs.
   Unordered pairs were counted, HAZMAT / Small-Snack / Large-Snack service
   lines and non-catalog SKUs dropped, quote-only OSK items excluded (they
   cannot be added to a cart), and pairs with fewer than 3 co-purchases
   discarded as noise. That leaves 228 anchor SKUs, 204 of them with two or
   more partners. Top pairs are things like ALK-09-1412 blue caps +
   VLV-09-1020 clear vials (285 orders) and MBP-01-1404 acetonitrile +
   MBP-02-1404 methanol (192).

   Format is "ANCHOR>P1,P2,P3" joined by ";" rather than JSON - same data,
   ~2KB smaller on the wire. REGENERATE it when order history has moved on;
   it is a snapshot, not a live feed.

   COVERAGE, of 576 sellable SKUs: 204 have two partners of their own; 259
   more are filled from FAM_RAW below (family-level co-purchase, mined from
   the same orders); the last 113 have nothing in the order history that
   reaches them. Those fall back to PROTO_RAW and then the curated
   FV3_MERCH.WORKFLOW protocol map, and the block is titled "Complete the
   protocol" instead - a guess about what belongs together should not be
   presented as an observed purchase pattern, which is exactly what the first
   cut of this did on 65% of PDPs.

   Additive asset; remove its loader line in sections/filtrous-v3-app.liquid
   to revert (the old Complete The Protocol block un-hides itself). */
(function () {
  'use strict';
  var BT_RAW =
    '17211>ALK-09-1412,MBP-01-1404,MBP-02-1404;17241>17211,VLV-09-1020,ALK-09-1212;470031180>503026;'+
    '503026>470031180;6150-1100>VLV-09-1020,ALK-09-1412,ALB-09-1414;'+
    '6150-1250>TPG-01-6007,WBM-07-0060,VLV-09-1020-K2;ACB-11-3722>VCV-11-1020,MBP-03-1404,MBP-01-1404;'+
    'ACH-20-1720>VCH-22-0100,VCH-22-0200,ALK-09-1412;'+
    'ACK-11-1712>VCV-11-1020,VLL-22-0200-K1,SFN-DR-4025;'+
    'ACM-20-1411>VCF-22-0200,VCH-22-0200,LLS-10-0003;ALB-09-1414>VLV-09-1020,LLS-10-0005,CCF-10-4150;'+
    'ALC-13-1102>VLV-13-1040,MBP-03-2404,VLV-13-0040;ALC-13-1301>VLV-13-0040,ALK-13-1321;'+
    'ALC-15-1100>VLV-15-0080,VLL-22-0200;ALC-15-8101>VLV-15-0080;'+
    'ALC-22-1100>VAL-24-0200,VLL-22-0200,ALC-24-1100;ALC-24-1100>VAL-24-0200,VLL-22-0200,ALC-22-1100;'+
    'ALK-08-1312>VAV-08-1020,SFN-AW-1030,VLL-22-0200-K1;'+
    'ALK-09-1212>VLV-09-1020,ALK-09-1512,ALK-09-1412;ALK-09-1312>ALK-09-1412,VAV-09-1020,ALK-09-1912;'+
    'ALK-09-1412>VLV-09-1020,VAV-09-1020,CCF-10-4500;ALK-09-1512>ALK-09-1212,VLV-09-1020,SFN-BR-1013;'+
    'ALK-09-1912>ALK-09-1412,ALK-09-1312,VAV-09-1020;ALK-10-1121>VLV-10-1020;'+
    'ALK-13-1321>VLV-13-0040,VLV-15-0080,ALK-15-1321;ALK-15-1321>VLV-15-0080,ALK-24-1102,ALK-13-1321;'+
    'ALK-24-1102>ALK-15-1321,VLL-24-0200,VLV-15-0080;ALS-09-1412>VLV-09-1020,VAV-09-1020,ALK-09-1412;'+
    'ANK-11-1022>VNV-11-1020,SFN-BR-1013,VLV-09-1020;ANS-11-1012>SFN-AR-2025,VNV-11-1020,VSV-11-1020;'+
    'ANX-11-1021>SFN-AR-2025,VAV-09-1020-K2,VSV-11-1020;BAB-11-0100>COV-11-0000-S,STM30-A;'+
    'BCT-00-0014>MBP-02-1404,CCF-10-4500,PTF-GS-1250;CCF-10-4150>CSF-10-4500,ALK-09-1412,CCF-10-4500;'+
    'CCF-10-4500>PTF-GS-1250,ALK-09-1412,VLV-09-1020;CCL-10-0015>PTF-GS-0010,MBP-01-1404,PTF-GS-1250;'+
    'CCL-10-1050>VAV-09-1020-K2,MBP-01-1404,MBP-01-2404;'+
    'CCL-10-3020>CCF-10-4500,CCM-10-0500,PTF-GS-0200;CCM-10-0500>LLS-10-0003,VAV-09-1020,ALS-09-1412;'+
    'CCN-10-0005>SFN-BR-1013;CCN-10-4015>PTF-GS-1250,CCF-10-4500,CCF-10-4150;'+
    'CCN-10-4020>SFN-BR-1013,LSS-10-0001,VLL-22-0200-K3;CCR-04-0050>PCM-21-0096,PCM-31-0096;'+
    'COV-11-0000-S>STM30-A,COV-CR-0020,UCP-01-0120;COV-12-0000-S>STM30-A,COV-CR-0020;'+
    'COV-CR-0020>COV-11-0000-S,COV-12-0000-S;CS4501>CS4502,CCF-10-4500,PTF-GS-1250;'+
    'CS4502>PTF-GS-1250,CS4501,CCF-10-4150;CS4503>CS4504,CS4502,PTF-GS-1250;'+
    'CS4504>CS4503,VLV-09-1020,SFN-CQ-1030;CS4601>LSS-10-0001,MBP-03-2404,SFN-BR-1013;'+
    'CS4602>ALK-09-1412,CCF-10-4150,PTF-GS-1000;CS4603>ALK-09-1412,CCF-10-4150,CS4602;'+
    'CSF-10-4500>CCF-10-4150,MBP-03-1404,MBP-01-1404;CTF-10-0150>MBP-02-1404,CCF-10-4500,FVP-B2-0020;'+
    'CUF-00-0100>SFN-BW-2030,MBP-01-1404,CUF-00-0300;CUF-00-0300>CUF-00-0100,SFN-BW-2030;'+
    'CUV-00-0045>LLS-10-0020,ALS-09-1412,CCM-10-0500;EXK-BD-0096>WKS-31-2020,MBP-04-3005,MBP-07-3005;'+
    'EXK-NL-0100>PCM-31-0096,PCW-38-0404,PTF-GS-1250;FFC-10-0500>PTF-GS-1250,CCN-10-4015,CCF-10-4500;'+
    'FFC-10-1000>FFC-10-0500;FPH-96-2020>WPR-11-2020;FVP-B2-0020>ALK-09-1412,VLV-09-1020,CCF-10-4500;'+
    'FVS-B2-0020>VLP-09-0003,VLV-15-0080,VLU-24-0400-K2;LC015-4>LC230-4,ALK-09-1412,CCF-10-4500;'+
    'LC230-4>MBP-01-1404,CCF-10-4500,MBP-02-1404;LLF-00-0010>LLS-00-0003,PTF-GS-1250;'+
    'LLF-10-0010>SFN-BR-1013,VLL-22-0200-K3,LSS-10-0001;'+
    'LLS-00-0003>CCF-10-4150,MBP-02-1404,CCF-10-4500;'+
    'LLS-00-0005>LLS-00-0010,VAV-09-1020-K2,CSF-10-4500;'+
    'LLS-00-0010>SFN-CW-2030,MBP-01-1404,ALK-09-1412;LLS-00-0020>ALK-09-1412,MBP-01-1404,VAV-09-1020;'+
    'LLS-10-0003>VLV-09-1020,ALK-09-1412,ACH-20-1720;LLS-10-0005>VLV-09-1020,ALK-09-1412,WBM-07-0060;'+
    'LLS-10-0010>VLV-09-1020,ALK-09-1412,ACH-20-1720;LLS-10-0020>CUV-00-0045,ALS-09-1412,CCM-10-0500;'+
    'LSS-10-0001>SFN-BR-1013,VLL-22-0200-K3,MBP-01-1404;LSS-10-0003>LSS-10-0001,LSS-10-0005;'+
    'LSS-10-0005>LSS-10-0003;MBP-01-1404>MBP-02-1404,MBP-03-1404,MBP-04-1404;'+
    'MBP-01-2404>MBP-02-2404,MBP-01-1404,MBP-02-1404;MBP-02-1404>MBP-01-1404,MBP-03-1404,ALK-09-1412;'+
    'MBP-02-2404>MBP-01-2404,MBP-03-2404,MBP-01-1404;MBP-03-1404>MBP-01-1404,MBP-02-1404,CSF-10-4500;'+
    'MBP-03-2404>MBP-02-2404,MBP-01-2404,MBP-04-2404;'+
    'MBP-03-4025>LSS-10-0001,SFN-BR-1013,VLV-09-1020-K2;'+
    'MBP-03-6030>MBP-07-3005,WKS-31-2020,WKC-51-2000;'+
    'MBP-04-1404>MBP-01-1404,VAV-09-1020-K2,MBP-01-2404;'+
    'MBP-04-2404>MBP-02-2404,MBP-03-2404,MBP-01-2404;MBP-04-3005>MBP-07-3005,MBP-03-6030,WKS-31-2020;'+
    'MBP-04-3200>MBP-07-3200,MBP-01-1404,ALK-09-1412;MBP-05-1404>LLS-00-0010,SFN-CW-1030,MBP-01-1404;'+
    'MBP-07-3005>WKS-31-2020,MBP-03-6030,MBP-04-3005;MBP-07-3200>ALK-09-1212,ALK-09-1412,VLV-09-1020;'+
    'MBP-08-1404>SFN-BR-1013,LSS-10-0001,VLL-22-0200-K3;'+
    'MBP-10-2070>VLV-09-1020-K2,6150-1250,TPG-01-6007;MBP-11-2070>SFN-CW-1030,VLV-09-1020-K2;'+
    'MBP-16-1404>MBP-02-1404;MBP-21-4425>WBD-01-1030,MBP-02-1404,ALK-09-1412;'+
    'PBS-10-0100>MBP-03-6030,MBP-07-3005,PTF-GS-0010;PCM-11-B096>PCM-31-0096,WBD-01-1030,MBP-21-4425;'+
    'PCM-21-0096>WKS-31-2020,PCM-31-0096,PCW-38-0404;PCM-31-0096>WKS-31-2020,PCW-38-0404,PCM-11-B096;'+
    'PCT-08-0102>PTF-GS-0010,WKS-31-2020,CCN-10-4015;PCT-0P-0000>PCM-31-0096,WKS-31-2020;'+
    'PCV-96-0201>PCM-21-0096,PTF-GS-0200,PCW-38-0404;PCV-96-0202>PTF-GS-0010,PTF-GS-0100,PTF-GS-0200;'+
    'PCW-38-0404>WKS-31-2020,PCM-31-0096,PTF-GS-0200;PDN-11-0100>TPG-01-6007,SPP-14-0002,UCP-01-0120;'+
    'PHB-04-0100>PHB-07-0100;PHB-07-0100>PHB-04-0100;PTB-YS-010K>SFN-BR-1013,CSF-10-4500,MBP-01-1404;'+
    'PTF-GS-0010>PTF-GS-0200,WKS-31-2020,PTF-GS-1250;PTF-GS-0020>PTF-GS-0100,PTF-GS-1250,PTF-GS-0200;'+
    'PTF-GS-0100>PTF-GS-0200,PTF-GS-0010,PTF-GS-1250;PTF-GS-0200>PTF-GS-1250,PTF-GS-0010,PTF-GS-0100;'+
    'PTF-GS-1000>PTF-GS-0200,CCF-10-4150,CCF-10-4500;PTF-GS-1250>CCF-10-4500,PTF-GS-0200,ALK-09-1412;'+
    'PTF-LS-0010>PTF-LS-0200,PTF-LS-1000,PTF-LS-0020;PTF-LS-0020>PTF-LS-0200,PTF-LS-1000,PTF-LS-0010;'+
    'PTF-LS-0200>PTF-LS-0020,PTF-LS-1000,PTF-LS-0010;PTF-LS-1000>PTF-LS-0200,PTF-LS-0020,PTF-LS-0010;'+
    'PTF-MS-1000>PTF-GS-0200,CTF-10-0150,MBP-01-1404;PTF-YS-005K>ALK-09-1412,CCF-10-4150,MBP-03-2404;'+
    'PTR-AN-0200>PTF-GS-0200;QBE-N3-0500>QBE-PX-0500;QBE-PX-0500>QBE-N3-0500,QBE-PY-0500,QBE-PZ-0500;'+
    'QBE-PY-0500>QBE-PZ-0500,QBE-PX-0500;QBE-PZ-0500>QBE-PY-0500,QBE-PX-0500;'+
    'QQX-02-2035-K>VAV-09-1020-K2,MBP-01-1404,MBP-02-2404;'+
    'QQX-50-0010-P>MBP-02-1404,ACM-20-1411,CSF-10-4500;'+
    'RBL-11-0125>VLV-09-1020-K2,LSS-10-0001,SFN-BR-1013;'+
    'RRS-01-0050>ALK-09-1512,SFN-BR-1013,ANK-11-1022;RRS-01-0100>PTF-GS-1250,WKS-31-2020,PTF-GS-0200;'+
    'RRS-02-0025>PTF-GS-0010;RTK-TN-0200>PCV-96-0201;SBF-10-0007>ALK-09-1412,ACH-20-1720,MBP-02-1404;'+
    'SBN-10-0007>MBP-01-2404,ALK-09-1412,MBP-02-1404;SBN-10-0018>ALK-09-1412,MBP-02-1404,ACH-20-1720;'+
    'SBN-10-0055>VAV-09-1020,MBP-02-1404,ALK-09-1312;SBN-10-0100>SBN-10-0055,ALK-09-1312,ALK-09-1412;'+
    'SFN-AR-1013>SFN-CR-2025,VLV-09-1020-K2,LLS-00-0003;'+
    'SFN-AR-1025>VLV-09-1020,PTF-GS-0200,ALS-09-1412;SFN-AR-2013>SFN-BR-2013,SFN-AR-2025,SFN-BR-1013;'+
    'SFN-AR-2025>VAV-09-1020-K2,VLV-09-1020-K2,VSV-11-1020;'+
    'SFN-AW-1030>VLV-09-1020-K2,ALK-09-1412,VLV-09-1020;'+
    'SFN-BR-1013>VLV-09-1020,VNV-11-1020,ALK-09-1212;SFN-BR-1025>VJP-09-0002,CCF-10-4500,MBP-01-1404;'+
    'SFN-BR-2013>CCF-10-4150,LLS-00-0003,CSF-10-4500;SFN-BR-2025>SFN-BR-1025,SFN-AR-2025,LLS-10-0005;'+
    'SFN-BW-2030>MBP-01-1404,CUF-00-0100,SFN-AR-2025;SFN-BX-0513>VJP-09-0002,ALK-09-1412,VLV-09-1020;'+
    'SFN-CQ-1030>VLV-09-1020-K2,VLV-09-1020,VLV-09-1020-K1;'+
    'SFN-CR-1025>ALK-09-1412,CCF-10-4150,ALK-09-1912;'+
    'SFN-CR-2025>LLS-00-0003,VLV-09-1020-K2,SFN-AR-1013;'+
    'SFN-CW-1030>VLV-09-1020,VLV-09-1020-K2,ALK-09-1412;'+
    'SFN-CW-2030>LLS-00-0010,ALB-09-1414,VAV-09-1020-K1;'+
    'SFN-DR-4025>ACK-11-1712,VCV-11-1020,VLL-22-0200-K1;SFN-ER-2025>SFN-BW-2030,SFN-AR-2025;'+
    'SFN-FR-2025>SFN-AR-2025;SFN-GR-1013>MBP-01-1404,MBP-03-1404;'+
    'SFN-GR-1025>ACH-20-1720,CCF-10-4500,MBP-02-1404;SFN-HP-1030>CCF-10-4150,ALK-09-1412,TPG-01-6007;'+
    'SPE-01-6500>MBP-02-1404,MBP-01-1404,MBP-03-1404;SPP-10-0005>SPP-14-0010,PDN-11-0100,TPG-01-6007;'+
    'SPP-10-0025>MBP-02-1404,ALK-09-1412,SFN-BX-0513;SPP-14-0001>PDN-11-0100,SPP-14-0002,TPG-01-6007;'+
    'SPP-14-0002>PDN-11-0100,TPG-01-6007,VLV-09-1020-K2;'+
    'SPP-14-0005>SPP-14-0002,PDN-11-0100,SFN-DR-4025;'+
    'SPP-14-0010>SPP-10-0005,VLV-09-1020-K2,PTF-GS-1250;'+
    'SPP-14-0025>SPP-10-0005,SPP-14-0010,CCF-10-4150;SPP-14-0050>CCF-10-4150,CCN-10-4015,PTF-GS-1250;'+
    'STM30-A>COV-11-0000-S,COV-12-0000-S,BAB-11-0100;TPG-01-6007>ALK-09-1412,WBM-07-0060,VLV-09-1020;'+
    'UCP-01-0120>PDN-11-0100,VLL-22-1200-K1,COV-11-0000-S;'+
    'VAE-09-0002>ALK-09-1412,VAV-09-1020,ALK-09-1212;VAE-09-1002>VAV-09-1020,ALK-09-1412,ALK-09-1312;'+
    'VAL-24-0200>ALC-22-1100,ALC-24-1100,ALK-24-1102;VAV-08-1020>ALK-08-1312,ALK-09-1412,VAV-09-1020;'+
    'VAV-09-1020>ALK-09-1412,ALK-09-1312,CCF-10-4150;'+
    'VAV-09-1020-K1>ALB-09-1414,VLV-09-1020-K1,SFN-CW-2030;'+
    'VAV-09-1020-K2>MBP-01-1404,SFN-BR-1013,MBP-04-1404;'+
    'VAV-09-1020-K3>VLV-09-1020-K3,MBP-02-1404,VLV-09-1020;VAV-13-0040>VLV-13-0040;'+
    'VAV-13-1040>ALK-13-1321,ALC-13-1102,VAV-09-1020;VCF-22-0200>ACM-20-1411,ACH-20-1720,LLS-10-0003;'+
    'VCH-22-0100>ACH-20-1720,ALK-09-1412,CCF-10-4500;VCH-22-0200>ACH-20-1720,MBP-02-2404,ALK-09-1412;'+
    'VCV-11-1020>ACK-11-1712,ACB-11-3722,VLL-22-0200-K1;'+
    'VDV-11-1020>ACB-11-3722,ALK-09-1412,CCF-10-4500;VJC-09-0002>17211,ALK-09-1412,VAV-09-1020;'+
    'VJF-09-0003>VLV-09-1020,ANK-11-1022,VNV-11-1020;VJP-09-0002>ALK-09-1412,VLV-09-1020,ACH-20-1720;'+
    'VLE-09-0002>VLV-09-1020-K2,ALK-09-1412;VLE-09-1002>ALK-09-1412,ALS-09-1412,VLP-09-0003;'+
    'VLL-22-0200>ALC-22-1100,ALC-24-1100,VAL-24-0200;'+
    'VLL-22-0200-K1>ALK-09-1412,MBP-02-2404,VAV-09-1020;'+
    'VLL-22-0200-K3>SFN-BR-1013,LSS-10-0001,MBP-01-1404;'+
    'VLL-22-1200-K1>UCP-01-0120,PDN-11-0100,LLS-00-0005;'+
    'VLL-24-0200>ALK-24-1102,VLV-13-0040,VLV-15-0080;VLP-09-0003>ALK-09-1412,ALS-09-1412,ALB-09-1414;'+
    'VLP-09-0020>ALS-09-1412;VLU-24-0400-K1>MBP-03-1404,MBP-01-1404,VAV-09-1020;'+
    'VLU-24-0400-K2>VLL-22-0200-K1,ACK-11-1712,SFN-DR-4025;VLV-08-1020>ALB-09-1414,VLV-09-1020;'+
    'VLV-09-1020>ALK-09-1412,ALB-09-1414,SFN-BR-1013;'+
    'VLV-09-1020-K1>VAV-09-1020-K1,SFN-CQ-1030,ALB-09-1414;'+
    'VLV-09-1020-K2>SFN-AW-1030,SFN-CQ-1030,SFN-CW-1030;'+
    'VLV-09-1020-K3>MBP-01-1404,VAV-09-1020-K3,SFN-CW-1030;VLV-10-1020>ALK-10-1121;'+
    'VLV-13-0040>VLV-15-0080,ALK-13-1321,VLL-24-0200;VLV-13-1040>ALC-13-1102,WBD-01-1030,ALK-13-1321;'+
    'VLV-15-0080>ALC-15-8101,VLV-13-0040,ALK-15-1321;'+
    'VNS-08-0010-K3>PTF-GS-0010,PTF-GS-0200,WKS-31-2020;'+
    'VNV-11-1020>ANK-11-1022,VLV-09-1020,SFN-BR-1013;'+
    'VSV-11-1020>SFN-AR-2025,VAV-09-1020-K2,ANS-11-1012;'+
    'WBD-01-1030>MBP-21-4425,PCM-11-B096,MBP-03-2404;WBD-01-1100>WBD-01-1030,CCF-10-4500,MBP-01-1404;'+
    'WBM-07-0060>TPG-01-6007,ALK-09-1412,LLS-10-0005;WBS-01-1010>CSF-10-4500;'+
    'WKC-51-2000>WKS-31-2020,WKS-31-2105,PTF-GS-0200;WKS-31-2020>WKC-51-2000,PTF-GS-0010,WKS-31-2105;'+
    'WKS-31-2105>WKS-31-2020,WKC-51-2000,PTF-GS-0200;WPR-11-2020>FPH-96-2020;WSM-11-2020>PCM-31-0096;'+
    'XSP-AE-0200>XSP-AE-1000;XSP-AE-1000>XSP-AE-0200';
  var BT = null;
  function bought(sku) {
    if (!BT) {
      BT = {};
      BT_RAW.split(';').forEach(function (row) {
        var i = row.indexOf('>');
        if (i > 0) BT[row.slice(0, i)] = row.slice(i + 1).split(',');
      });
    }
    return BT[String(sku || '').toUpperCase()] || null;
  }

  /* Family-level co-purchase, for the SKUs whose own pair counts are too thin
     to say anything. Same 8,562 orders: for each family, the SKUs outside it
     that show up in its orders far more often than in orders generally
     (lift), floor of 5 co-occurrences or 1% of the family's orders, whichever
     is larger. Ranking by raw count instead just returns the shop's five
     bestsellers on every PDP, which is what the old fallback effectively did.
     "family>SKU,SKU,..." rows, best first; the renderer takes the first two
     that are in stock. REGENERATE alongside BT_RAW. */
  var FAM_RAW =
    '96-deep-well-plates-v2>PCW-38-0404,MBP-04-3005,PCT-08-0102,RRS-01-0100,MBP-07-3005,PCM-31-0096;'+
    'autosampler-kits-v2>VSV-11-1020,SFN-CQ-1030,CCL-10-1050,MBP-03-4025,SPP-14-0002,SFN-CW-1030;'+
    'autosampler-vials-caps-v2>FVP-B2-0020,SFN-CR-1025,SFN-BX-0513,SBF-10-0007,6150-1100,VLE-09-1002;'+
    'biological-specimen-collection-v2>SFN-BX-0513,FVP-B2-0020,STM30-A,BCT-00-0014,CTF-10-0150,COV-CR-0020;'+
    'biology-buffers-v2>WBD-01-1030,VLV-13-1040,ALC-13-1102,FVP-B2-0020,PCM-11-B096,SFN-BX-0513;'+
    'centrifuge-tubes-v2>SBN-10-0018,FVP-B2-0020,SFN-BX-0513,SBF-10-0007,SBN-10-0007,BCT-00-0014;'+
    'culture-dishes-v2>SPP-14-0002,SPP-14-0001,UCP-01-0120,SPP-10-0005,VLL-22-1200-K1,TPG-01-6007;'+
    'epa-voa-vials-v2>ALK-24-1102,ALK-15-1321,SFN-DR-4025,ACK-11-1712,VLV-15-0080,VLL-24-0200;'+
    'extraction-kits-v2>MBP-04-3005,PCW-38-0404,PCM-31-0096,MBP-07-3005,WKS-31-2020;'+
    'filter-paper-v2>WBM-07-0060,TPG-01-6007,ALB-09-1414,SFN-AW-1030,VLV-09-1020,ALK-09-1412;'+
    'filter-vials-v2>CTF-10-0150,SFN-BX-0513,SBF-10-0007,BCT-00-0014,ALK-24-1102,SBN-10-0018;'+
    'glassware-plastics-v2>LLS-10-0020,PTF-GS-0020,FVP-B2-0020,SFN-BX-0513,SBN-10-0018,PTF-GS-1000;'+
    'gloves-v2>PTF-GS-1000,MBP-03-4025,LSS-10-0001,CCN-10-4020,CCN-10-4015,VLL-22-0200-K3;'+
    'graduated-pipettes-v2>6150-1250,WBM-07-0060,SPP-14-0002,SFN-CR-1025,SPP-10-0005,PDN-11-0100;'+
    'headspace-vials-v2>SBF-10-0007,FVP-B2-0020,SFN-BX-0513,SBN-10-0018,CTF-10-0150,BCT-00-0014;'+
    'lts-pipette-tips-v2>VAV-09-1020-K1,SFN-BW-2030,VLL-22-0200-K1,SFN-AR-2025,PTF-GS-0200,VNV-11-1020;'+
    'membrane-filters-v2>CCN-10-4015,PTF-GS-1250,CCF-10-4500,PTF-GS-0200,CCF-10-4150;'+
    'pcr-kits-reagents-v2>EXK-BD-0096;'+
    'pcr-plates-v2>PCM-21-0096,PCM-31-0096,PTF-GS-0020,WKS-31-2105,PCM-11-B096,WKC-51-2000;'+
    'quechers-v2>VAV-09-1020-K2,MBP-02-2404,MBP-01-1404,MBP-02-1404;'+
    'sample-preparation-v2>SBN-10-0055,VJF-09-0003,17211,MBP-03-1404,MBP-02-1404,CCF-10-4500;'+
    'scintillation-vials-v2>MBP-08-1404,LLF-10-0010,ALK-15-1321,SBN-10-0007,ACK-11-1712,SFN-DR-4025;'+
    'sealing-membranes-v2>PCW-38-0404,WBD-01-1030,PCV-96-0201,WKS-31-2105,RRS-01-0100,MBP-07-3005;'+
    'serological-pipettes-v2>PDN-11-0100,SFN-BX-0513,FVP-B2-0020,TPG-01-6007,SBF-10-0007,CCN-10-4015;'+
    'solvents-v2>FVP-B2-0020,SFN-BX-0513,CTF-10-0150,SBN-10-0018,SBF-10-0007,LSS-10-0001;'+
    'strip-tubes-v2>WKS-31-2105,PTF-GS-0010,WKS-31-2020,WKC-51-2000,CCN-10-4015;'+
    'syringe-filters-v2>LLF-10-0010,CUF-00-0100,FVP-B2-0020,VSV-11-1020,LSS-10-0001,SBF-10-0007;'+
    'syringes-v2>MBP-08-1404,FVP-B2-0020,SFN-BX-0513,SFN-CW-2030,MBP-03-4025,SBN-10-0018;'+
    'universal-tips-v2>SFN-BX-0513,FVP-B2-0020,CS4601,CS4502,CS4602,BCT-00-0014;'+
    'vial-inserts-v2>SBF-10-0007,FVP-B2-0020,SFN-BX-0513,SBN-10-0007,SBN-10-0018,SBN-10-0100;'+
    'vtm-v2>COV-12-0000-S,COV-11-0000-S;'+
    'weighing-v2>6150-1250,SFN-CR-1025,VLV-13-1040,TPG-01-6007,PCM-11-B096,LLS-10-0005';
  var FAM = null;
  function famPick(f) {
    if (!FAM) {
      FAM = {};
      FAM_RAW.split(';').forEach(function (row) {
        var i = row.indexOf('>');
        if (i > 0) FAM[row.slice(0, i)] = row.slice(i + 1).split(',');
      });
    }
    return FAM[f] || [];
  }

  /* Tier-3 override, keyed by SKU first and then by family. The WORKFLOW map
     relates whole families, and for two families that is the wrong grain:

     CHEMISTRY-REAGENTS is not one kind of thing, it is three - assay reagents,
     CALIBRATORS that set the assay's curve, and CONTROL sera that verify it.
     A clinical chemistry result is only a number if all three are on the
     bench, so the companion of an assay reagent is its matched calibrator and
     its control, not another analyte. Lipid assays take the lipids control,
     CO2 has its own matched calibrator/control pair, the rest run off the
     multi-analyte serum. UNVERIFIED: whether the multi-analyte serum carries
     assigned values for HbA1c (CHM-A1C-0250) and hs-CRP (CHM-HCR-0270) -
     confirm against the vendor's value sheet; if it does not, give those two
     their own rows.

     NABS are nanobody resins for co-immunoprecipitation. What a co-IP consumes
     is a mild non-ionic wash buffer, 1.5 mL tubes that survive the heated SDS
     elution (lid-lock, not snap cap), and the sample buffer that elution runs
     into before SDS-PAGE. The catalog has no magnetic separation rack; if one
     is ever listed it belongs at the front of that row. */
  var PROTO_RAW =
    'CHM-CO2-0800>CHM-CDC-3000,CHM-CDQ-3000;CHM-CDC-3000>CHM-CDQ-3000,CHM-CO2-0800;'+
    'CHM-CDQ-3000>CHM-CDC-3000,CHM-CO2-0800;CHM-HDL-0500>CHM-HDC-1000,CHM-LP1-3000;'+
    'CHM-HDC-1000>CHM-HDL-0500,CHM-LP1-3000;CHM-LDL-0500>CHM-LDC-1000,CHM-LP1-3000;'+
    'CHM-LDC-1000>CHM-LDL-0500,CHM-LP1-3000;CHM-CHO-0500>CHM-MCL-3000,CHM-LP1-3000;'+
    'CHM-TRG-0500>CHM-MCL-3000,CHM-LP1-3000;CHM-LP1-3000>CHM-LP2-3000,CHM-MCL-3000;'+
    'CHM-LP2-3000>CHM-LP1-3000,CHM-MCL-3000;CHM-MCL-3000>CHM-MQ1-5000,CHM-MQ2-5000;'+
    'CHM-MQ1-5000>CHM-MQ2-5000,CHM-MCL-3000;CHM-MQ2-5000>CHM-MQ1-5000,CHM-MCL-3000;'+
    'chemistry-reagents>CHM-MCL-3000,CHM-MQ1-5000,CHM-MQ2-5000;'+
    'nabs-v2>PBT-10-0100,CCL-10-0015,TGS-06-0005,PBS-10-0100,CCN-10-4015';
  var PROTO = null;
  function protoPick(k) {
    if (!PROTO) {
      PROTO = {};
      PROTO_RAW.split(';').forEach(function (row) {
        var i = row.indexOf('>');
        if (i > 0) PROTO[row.slice(0, i).toUpperCase()] = row.slice(i + 1).split(',');
      });
    }
    return PROTO[String(k || '').toUpperCase()] || [];
  }

  /* mirrors isOskQuote() in filtrous-v3.js - quote items have no cart price */
  function isQuote(sku) {
    var s = String(sku || '').toUpperCase();
    return s.indexOf('OSK') >= 0 || s === 'EXK-BD-0096-PP';
  }
  function money(n) {
    n = parseFloat(n);
    return isNaN(n) ? '' : '$' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (m) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m];
    });
  }

  /* Diagnostic surface: read window.FV3_FBT_DEBUG in the console. */
  var DBG = window.FV3_FBT_DEBUG = { taps: 0, idx: false, skus: 0, passes: 0, built: [], err: null };

  /* ---- catalog index: read-only tap, same pattern as the other shims ---- */
  var IDX = null, BY_SKU = {}, BY_FAM = {}, waiting = [];
  var orig = window.fetch;
  if (orig) {
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = orig.apply(this, arguments);
      if (String(url).indexOf('catalog-index') === -1) return p;
      DBG.taps++;
      return p.then(function (res) {
        if (res && res.ok) {
          /* clone() throws synchronously if the body was already read, and a
             throw here would reject the index promise for the whole app. */
          var c = null;
          try { c = res.clone(); } catch (e) { DBG.err = 'clone: ' + e; return res; }
          c.json().then(function (d) {
            IDX = d; DBG.idx = true;
            (d.products || []).forEach(function (x) {
              if (!x || !x.sku) return;
              BY_SKU[String(x.sku).toUpperCase()] = x;
              var f = x.primary_family;
              if (f) { (BY_FAM[f] = BY_FAM[f] || []).push(x); }
            });
            DBG.skus = Object.keys(BY_SKU).length;
            waiting.splice(0).forEach(function (fn) { try { fn(); } catch (e) {} });
            schedule();
          }).catch(function (e) { DBG.err = 'json: ' + e; });
        }
        return res;
      });
    };
  }

  function usable(p) {
    return !!(p && p.sku && p.vid && p.handle && p.available !== false && !isQuote(p.sku));
  }

  /* Three tiers, and the block only claims "frequently bought together" while
     it is standing on order history:

       1. this exact SKU's real co-purchase partners (BT_RAW, 204 SKUs);
       2. what this SKU's FAMILY is bought with (FAM_RAW, +259 SKUs). Same
          orders, aggregated to family level, which is where the data is
          dense enough to be worth anything;
       3. PROTO_RAW, then the curated FV3_MERCH.WORKFLOW protocol map (the
          last 113 SKUs, none of which the orders reach).

     Tier 3 is a guess about what goes with what, not an observation, so it
     gets the honest heading instead. Before this split every one of those 372
     SKUs was showing the first product in a related family - the same two
     items on every PDP in the family, presented as a purchase pattern. */
  function partnersFor(sku) {
    var key = String(sku).toUpperCase();
    var me = BY_SKU[key];
    var out = [], seen = {};
    seen[key] = 1;
    function take(s) {
      var p = BY_SKU[String(s).toUpperCase()];
      if (!p || !usable(p) || seen[p.sku.toUpperCase()]) return false;
      seen[p.sku.toUpperCase()] = 1; out.push(p); return true;
    }

    (bought(key) || []).forEach(function (s) { if (out.length < 2) take(s); });
    if (out.length < 2 && me) {
      famPick(me.primary_family).forEach(function (s) { if (out.length < 2) take(s); });
    }
    var fromOrders = out.length;

    if (out.length < 2 && me) {
      protoPick(key).forEach(function (s) { if (out.length < 2) take(s); });
      protoPick(me.primary_family).forEach(function (s) { if (out.length < 2) take(s); });
    }
    if (out.length < 2 && me) {
      var M = window.FV3_MERCH;
      var fams = (M && M.WORKFLOW && M.WORKFLOW[me.primary_family]) || [];
      for (var i = 0; i < fams.length && out.length < 2; i++) {
        var list = BY_FAM[fams[i]] || [];
        for (var j = 0; j < list.length; j++) { if (take(list[j].sku)) break; }
      }
    }
    return { items: out.slice(0, 2), grounded: out.length === fromOrders };
  }

  function arrowsHTML(label) {
    function b(dir, d, dis) {
      return '<button type="button" aria-label="Scroll ' + esc(label) + ' ' + dir + '"' + (dis ? ' disabled' : '') +
        '><svg viewBox="0 0 16 16" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" ' +
        'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + d + '"/></svg></button>';
    }
    return '<div class="fv3-arrows">' + b('backward', 'M10 12L6 8l4-4', 1) + b('forward', 'M6 4l4 4-4 4', 0) + '</div>';
  }
  function armArrows(rail, box) {
    var btns = box.querySelectorAll('.fv3-arrows button');
    if (btns.length < 2) return;
    function sync() {
      btns[0].disabled = rail.scrollLeft <= 2;
      btns[1].disabled = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 2;
    }
    btns[0].addEventListener('click', function () { rail.scrollBy({ left: -rail.clientWidth * 0.8, behavior: 'smooth' }); });
    btns[1].addEventListener('click', function () { rail.scrollBy({ left: rail.clientWidth * 0.8, behavior: 'smooth' }); });
    rail.addEventListener('scroll', sync); setTimeout(sync, 80);
  }

  /* Card markup mirrors the Recommended For You rail, minus Quick view. */
  function railCard(p) {
    return '<a class="fv3-rv-card" href="/products/' + esc(p.handle) + '">' +
      '<div class="fv3-rv-img">' + (p.image ? '<img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') +
      '</div><div class="fv3-rv-t">' + esc(p.title) + '</div><div class="fv3-rv-sku">' + esc(p.sku) + '</div>' +
      '<div class="fv3-rv-p">' + (isQuote(p.sku) ? 'Call for Quote' : money(p.price)) + '</div></a>';
  }

  /* ---------------- Frequently bought together ---------------- */
  function buildFbt(pdp) {
    if (pdp.querySelector('.fv3-fbt')) return;
    var sku = window.FV3_CONFIG && window.FV3_CONFIG.pdpSku;
    if (!sku) return;
    var me = BY_SKU[String(sku).toUpperCase()];
    if (!usable(me)) return;
    var rec = partnersFor(sku);
    if (!rec.items.length) return;
    var items = [me].concat(rec.items);
    var title = rec.grounded ? 'Frequently bought together' : 'Complete the protocol';

    var sec = document.createElement('section');
    sec.className = 'fv3-fbt';
    sec.setAttribute('aria-label', title);
    var h = '<div class="fv3-rv-head"><h2>' + title + '</h2></div><div class="fbt-in"><div class="fbt-items">';
    items.forEach(function (p, i) {
      h += (i ? '<span class="fbt-plus" aria-hidden="true">+</span>' : '') +
        '<div class="fbt-item"><label class="fbt-pick"><input type="checkbox" checked data-vid="' + esc(p.vid) +
        '" data-price="' + esc(p.price) + '" aria-label="Include ' + esc(p.title) + '"><span class="fbt-box" aria-hidden="true"></span></label>' +
        '<a class="fbt-art" href="/products/' + esc(p.handle) + '" tabindex="-1" aria-hidden="true">' +
        (p.image ? '<img src="' + esc(p.image) + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div class="fbt-meta">' + (i === 0 ? '<b>This item:</b> ' : '') +
        '<a href="/products/' + esc(p.handle) + '">' + esc(p.title) + '</a>' +
        '<div class="fbt-price">' + money(p.price) + '</div></div></div>';
    });
    h += '</div><div class="fbt-buy"><div class="fbt-total">Total price: <b></b></div>' +
      '<button type="button" class="fbt-add"></button><div class="fbt-note" role="status"></div></div></div>';
    sec.innerHTML = h;

    var boxes = [].slice.call(sec.querySelectorAll('.fbt-pick input'));
    var totalEl = sec.querySelector('.fbt-total b');
    var addBtn = sec.querySelector('.fbt-add');
    var note = sec.querySelector('.fbt-note');
    function sync() {
      var n = 0, sum = 0;
      boxes.forEach(function (b) { if (b.checked) { n++; sum += parseFloat(b.getAttribute('data-price')) || 0; } });
      totalEl.textContent = money(sum);
      addBtn.textContent = n === 1 ? 'Add to Cart' : 'Add all ' + n + ' to Cart';
      addBtn.disabled = n === 0;
    }
    boxes.forEach(function (b) { b.addEventListener('change', sync); });
    sync();

    addBtn.addEventListener('click', function () {
      var picked = boxes.filter(function (b) { return b.checked; })
        .map(function (b) { return { id: Number(b.getAttribute('data-vid')), quantity: 1 }; });
      if (!picked.length) return;
      addBtn.disabled = true; note.textContent = '';
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: picked })
      }).then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
        .then(function () {
          addBtn.textContent = 'Added to cart';
          note.textContent = picked.length + (picked.length === 1 ? ' item added.' : ' items added.');
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          [].slice.call(document.querySelectorAll('.fv3-cart .count, .fh3-cart .count')).forEach(function (el) {
            el.textContent = cart.item_count;
          });
          document.dispatchEvent(new CustomEvent('fv3:cart-updated', { detail: cart }));
          setTimeout(function () { addBtn.disabled = false; sync(); }, 1600);
        })
        .catch(function () {
          note.textContent = 'Could not add to cart. Please try again.';
          addBtn.disabled = false; sync();
        });
    });
    return sec;
  }

  /* ---------------- Products related to this item ---------------- */
  var relCache = null, relBuilding = false;
  function buildRelated(pdp) {
    /* relBuilding matters: the fetch is async and run() fires many times, so
       without it several passes all clear the "already there?" check before
       any of them inserts, and the section renders two or three times over. */
    if (relBuilding || pdp.querySelector('.fv3-rel')) return;
    var pid = window.FV3_CONFIG && window.FV3_CONFIG.pdpProductId;
    if (!pid) return;
    function render(list) {
      relBuilding = false;
      if (!list || !list.length || pdp.querySelector('.fv3-rel')) return;
      var sec = document.createElement('section');
      sec.className = 'fv3-rel';
      sec.setAttribute('aria-label', 'Products related to this item');
      sec.innerHTML = '<div class="fv3-rv-head"><h2>Products related to this item</h2>' +
        arrowsHTML('Products related to this item') + '</div><div class="fv3-rv-rail">' +
        list.map(railCard).join('') + '</div>';
      pdp.appendChild(sec);
      DBG.built.push('related');
      armArrows(sec.querySelector('.fv3-rv-rail'), sec);
      schedule();
    }
    relBuilding = true;
    if (relCache) return render(relCache);
    fetch('/recommendations/products.json?product_id=' + encodeURIComponent(pid) + '&limit=12&intent=related')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var anchor = String((window.FV3_CONFIG && window.FV3_CONFIG.pdpSku) || '').toUpperCase();
        relCache = ((j && j.products) || []).map(function (p) {
          var v = (p.variants || [])[0] || {};
          return { sku: v.sku || '', title: p.title, handle: p.handle, price: (p.price || 0) / 100,
                   image: p.featured_image || (p.images || [])[0] || '', vid: v.id, available: p.available };
        }).filter(function (p) { return p.sku && p.handle && p.sku.toUpperCase() !== anchor; }).slice(0, 10);
        render(relCache);
      }).catch(function () { relBuilding = false; });
  }

  /* ---------------- rail cards: qty stepper + add to cart ----------------
     Applies to EVERY .fv3-rv-card on the PDP (Recommended, Related, Recently
     viewed), restoring the per-product controls the retired Complete The
     Protocol cards used to carry. The card itself is an <a>, so the controls
     cannot live inside it - each card is wrapped in a cell and the actions are
     appended as a sibling. The cell then takes over the card's white frame so
     the buy row reads as part of the card instead of floating under it. */
  function addToCart(vid, qty, btn) {
    var label = btn.textContent;
    btn.disabled = true; btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(vid), quantity: qty }] })
    }).then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        [].slice.call(document.querySelectorAll('.fv3-cart .count, .fh3-cart .count')).forEach(function (el) {
          el.textContent = cart.item_count;
        });
        document.dispatchEvent(new CustomEvent('fv3:cart-updated', { detail: cart }));
        btn.textContent = 'Added';
        setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1400);
      })
      .catch(function () { btn.textContent = label; btn.disabled = false; });
  }

  function wireCardActions(act) {
    var b = act.querySelector('.fbt-step b');
    var dec = act.querySelector('.fbt-step .dec');
    var inc = act.querySelector('.fbt-step .inc');
    var add = act.querySelector('button.fbt-cardadd');
    var n = 1;
    function stop(e) { e.preventDefault(); e.stopPropagation(); }
    if (dec) dec.addEventListener('click', function (e) { stop(e); n = Math.max(1, n - 1); b.textContent = n; });
    if (inc) inc.addEventListener('click', function (e) { stop(e); n = n + 1; b.textContent = n; });
    if (add) add.addEventListener('click', function (e) {
      stop(e);
      var vid = add.getAttribute('data-vid');
      if (vid) addToCart(vid, n, add);
    });
  }

  function enhanceCards(pdp) {
    var changed = false;
    var cards = pdp.querySelectorAll('.fv3-rv-card');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (card.getAttribute('data-fbt-card')) continue;
      card.setAttribute('data-fbt-card', '1');
      changed = true;

      /* "Full kit" is rendered inside the image box and positioned over the
         photo. Reparent it to the card so it anchors to the card's top-left
         corner instead, in the strip the CSS below reserves above the image. */
      var badge = card.querySelector('.fv3-up-badge');
      if (badge && badge.parentNode !== card) card.insertBefore(badge, card.firstChild);

      var skuEl = card.querySelector('.fv3-rv-sku');
      var pr = skuEl ? BY_SKU[skuEl.textContent.trim().toUpperCase()] : null;
      if (!pr || !card.parentNode) continue;

      var cell = document.createElement('div');
      cell.className = 'fv3-cardcell';
      card.parentNode.insertBefore(cell, card);
      cell.appendChild(card);

      var act = document.createElement('div');
      act.className = 'fbt-cardact';
      if (isQuote(pr.sku)) {
        act.innerHTML = '<a class="fbt-cardadd" href="/pages/contact">Call for Quote</a>';
      } else if (!pr.vid || pr.available === false) {
        act.innerHTML = '<button type="button" class="fbt-cardadd" disabled>Sold Out</button>';
      } else {
        act.innerHTML = '<div class="fbt-step"><button type="button" class="dec" aria-label="Decrease quantity">&minus;</button>' +
          '<b aria-live="polite">1</b><button type="button" class="inc" aria-label="Increase quantity">+</button></div>' +
          '<button type="button" class="fbt-cardadd" data-vid="' + esc(pr.vid) + '">Add to cart</button>';
      }
      cell.appendChild(act);
      wireCardActions(act);
    }
    return changed;
  }

  /* ---------------- tabs: Specifications first ---------------- */
  function orderTabs(pdp) {
    var row = pdp.querySelector('.fv3-tabrow');
    if (!row || row.getAttribute('data-fbt-tabs')) return false;
    var specs = row.querySelector('[data-tab="specs"]');
    var desc = row.querySelector('[data-tab="desc"]');
    if (!specs || !desc) return false;
    row.setAttribute('data-fbt-tabs', '1');
    row.insertBefore(specs, desc);
    if (specs.getAttribute('aria-selected') !== 'true') specs.click();
    return true;
  }

  /* ---------------- build (position is CSS, see below) ---------------- */
  function run() {
    var pdp = document.querySelector('#fv3-app .fv3-pdp');
    if (!pdp || !IDX) return false;
    var changed = orderTabs(pdp);
    var grid = pdp.querySelector('.fv3-pdp-grid');
    if (!grid) return changed;

    /* Only BUILD here - sequence is decided by CSS `order` below, never by DOM
       moves. filtrous-pdp-merch.js re-inserts .fv3-rec on its own observer
       every pass, so any reordering here is undone immediately: the two
       modules ping-ponged for 73 passes and still settled wrong. CSS ordering
       cannot be undone by another script's insertBefore. */
    var fbt = pdp.querySelector('.fv3-fbt') || buildFbt(pdp);
    if (fbt && !fbt.isConnected) { pdp.appendChild(fbt); changed = true; DBG.built.push('fbt'); }

    buildRelated(pdp);
    if (enhanceCards(pdp)) changed = true;

    /* belt and braces: if an async pass doubled a section up, keep the first. */
    ['.fv3-fbt', '.fv3-rel'].forEach(function (sel) {
      var all = pdp.querySelectorAll(sel);
      for (var i = 1; i < all.length; i++) { all[i].parentNode.removeChild(all[i]); changed = true; }
    });

    return changed;
  }

  if (!document.getElementById('fbt-css')) {
    var st = document.createElement('style');
    st.id = 'fbt-css';
    st.textContent =
      '#fv3-app .fv3-buy .fv3-pairs{display:none !important;}' +
      /* section sequence, immune to DOM reshuffling by the other PDP modules */
      '#fv3-app .fv3-pdp{display:flex;flex-direction:column;}' +
      '#fv3-app .fv3-pdp>.fv3-pdp-grid{order:1;}' +
      '#fv3-app .fv3-pdp>.fv3-fbt{order:2;}' +
      '#fv3-app .fv3-pdp>.fv3-rel{order:3;}' +
      '#fv3-app .fv3-pdp>.fv3-cmp{order:4;}' +
      '#fv3-app .fv3-pdp>.fv3-rec{order:5;}' +
      '#fv3-app .fv3-pdp>.fv3-rv{order:6;}' +
      /* Every lower-PDP section carries the theme's own section rule and
         rhythm. .fv3-rec and .fv3-rv already had it; the two this file adds
         did not, so the stack alternated 26 / 66 / 8 / 66 px between
         headings. .fv3-pdp supplies the 22px side padding, so these get
         NO horizontal padding of their own - the old 22px here indented the
         FBT heading past every other heading on the page. */
      '#fv3-app .fv3-pdp>.fv3-pdp-grid{margin-bottom:8px;}' +
      '#fv3-app .fv3-pdp>.fv3-fbt,#fv3-app .fv3-pdp>.fv3-rel{margin:44px 0 8px;border-top:1px solid var(--line,#e3e9ee);padding:22px 0 0;}' +
      '#fv3-app .fv3-fbt .fbt-in{display:flex;align-items:flex-start;gap:32px;flex-wrap:wrap;}' +
      /* one row: never wrap, let the items share the width instead */
      '#fv3-app .fv3-fbt .fbt-items{display:flex;align-items:flex-start;gap:12px;flex:1 1 520px;flex-wrap:nowrap;min-width:0;}' +
      '#fv3-app .fv3-fbt .fbt-item{display:flex;align-items:flex-start;gap:9px;flex:1 1 0;min-width:0;}' +
      '#fv3-app .fv3-pdp .fv3-qv{display:none !important;}' +
      /* The cell, not the <a>, is the card box now: the buy row has to sit
         INSIDE the white panel, and it cannot live inside the anchor. So the
         anchor goes transparent and the cell inherits its frame and hover. */
      '#fv3-app .fv3-pdp .fv3-rv-rail{grid-auto-columns:260px;}' +
      '#fv3-app .fv3-pdp .fv3-cardcell{display:flex;flex-direction:column;flex:0 0 auto;background:#fff;border:1px solid var(--line,#e3e9ee);border-radius:10px;padding:8px 12px 12px;}' +
      '#fv3-app .fv3-pdp .fv3-cardcell:hover{border-color:rgba(33,214,179,.45);box-shadow:0 4px 16px rgba(8,47,75,.08);}' +
      '#fv3-app .fv3-pdp .fv3-cardcell>.fv3-rv-card{position:relative;flex:1 1 auto;background:none;border:0;border-radius:0;padding:28px 0 0;}' +
      '#fv3-app .fv3-pdp .fv3-cardcell>.fv3-rv-card:hover{border-color:transparent;box-shadow:none;}' +
      /* a 1:1 box is mostly empty air once the card is this wide */
      '#fv3-app .fv3-pdp .fv3-cardcell .fv3-rv-img{max-height:190px;}' +
      '#fv3-app .fv3-pdp .fbt-cardact{display:flex;align-items:center;gap:8px;padding:10px 0 0;margin-top:auto;}' +
      '#fv3-app .fv3-pdp .fbt-step{display:inline-flex;align-items:center;border:1px solid var(--line,#e3e9ee);border-radius:7px;overflow:hidden;background:#fff;flex:none;}' +
      '#fv3-app .fv3-pdp .fbt-step button{width:24px;height:30px;background:var(--panel,#f7fafb);border:0;color:var(--ink,#12222f);font-size:15px;font-weight:600;line-height:1;cursor:pointer;}' +
      '#fv3-app .fv3-pdp .fbt-step button:hover{background:#e8f6f2;}' +
      '#fv3-app .fv3-pdp .fbt-step b{min-width:26px;height:30px;display:inline-flex;align-items:center;justify-content:center;background:#fff;font-size:13px;font-weight:600;font-variant-numeric:tabular-nums;}' +
      '#fv3-app .fv3-pdp .fbt-cardadd{flex:1 1 auto;height:30px;border:0;border-radius:7px;background:var(--teal,#21D6B3);color:#062334;font:inherit;font-size:12.5px;font-weight:700;cursor:pointer;display:flex;align-items:center;justify-content:center;text-decoration:none;}' +
      '#fv3-app .fv3-pdp .fbt-cardadd:hover{background:#1bc4a4;}' +
      '#fv3-app .fv3-pdp .fbt-cardadd[disabled]{background:var(--line,#e3e9ee);color:var(--faint,#5F7181);cursor:not-allowed;}' +
      /* Top-left corner of the card, in a strip reserved on EVERY card in the
         rail - float it over the photo and it covers the product; leave it in
         flow and only the flagged cards get pushed down, so images and titles
         stop lining up across the row. */
      '#fv3-app .fv3-pdp .fv3-up-badge{position:absolute !important;top:0;left:0;margin:0;}' +
      '#fv3-app .fv3-fbt .fbt-plus{align-self:center;font-size:20px;color:var(--mut,#5c6f7e);line-height:1;}' +
      '#fv3-app .fv3-fbt .fbt-pick{position:relative;display:inline-flex;flex:0 0 auto;padding-top:2px;cursor:pointer;}' +
      '#fv3-app .fv3-fbt .fbt-pick input{position:absolute;opacity:0;width:18px;height:18px;margin:0;cursor:pointer;}' +
      '#fv3-app .fv3-fbt .fbt-box{width:18px;height:18px;border:1px solid #b9c6cf;border-radius:4px;background:#fff;display:block;}' +
      '#fv3-app .fv3-fbt .fbt-pick input:checked+.fbt-box{background:var(--dteal,#0d7d68);border-color:var(--dteal,#0d7d68);' +
      'background-image:url("data:image/svg+xml;utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3E%3Cpath d=%27M3 8.5l3 3 7-7%27 fill=%27none%27 stroke=%27white%27 stroke-width=%272.2%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E");background-size:14px;background-position:center;background-repeat:no-repeat;}' +
      '#fv3-app .fv3-fbt .fbt-pick input:focus-visible+.fbt-box{outline:2px solid var(--teal,#21D6B3);outline-offset:2px;}' +
      '#fv3-app .fv3-fbt .fbt-art{flex:0 0 64px;width:64px;height:64px;border:1px solid var(--line,#e3e9ee);border-radius:8px;background:#fff;display:flex;align-items:center;justify-content:center;overflow:hidden;}' +
      '#fv3-app .fv3-fbt .fbt-art img{max-width:100%;max-height:100%;object-fit:contain;}' +
      '#fv3-app .fv3-fbt .fbt-meta{font-size:13px;line-height:1.4;min-width:0;overflow-wrap:anywhere;}' +
      '#fv3-app .fv3-fbt .fbt-meta a{color:var(--ink,#12222f);text-decoration:none;}' +
      '#fv3-app .fv3-fbt .fbt-meta a:hover{color:var(--dteal,#0d7d68);text-decoration:underline;}' +
      '#fv3-app .fv3-fbt .fbt-price{font-weight:700;margin-top:3px;}' +
      '#fv3-app .fv3-fbt .fbt-buy{flex:0 0 auto;display:flex;flex-direction:column;gap:8px;align-items:flex-start;min-width:200px;}' +
      '#fv3-app .fv3-fbt .fbt-total{font-size:15px;color:var(--ink,#12222f);}' +
      '#fv3-app .fv3-fbt .fbt-total b{font-weight:700;}' +
      '#fv3-app .fv3-fbt .fbt-add{background:var(--teal,#21D6B3);color:#062334;border:0;border-radius:8px;padding:10px 22px;font:inherit;font-weight:700;font-size:13.5px;cursor:pointer;}' +
      '#fv3-app .fv3-fbt .fbt-add:hover{background:#1bc4a4;}' +
      '#fv3-app .fv3-fbt .fbt-add[disabled]{background:var(--line,#e3e9ee);color:var(--faint,#5F7181);cursor:not-allowed;}' +
      '#fv3-app .fv3-fbt .fbt-note{font-size:12.5px;color:var(--mut,#5c6f7e);min-height:16px;}' +
      /* phones are too narrow for three across, so there only it wraps */
      '@media (max-width:820px){#fv3-app .fv3-pdp>.fv3-fbt,#fv3-app .fv3-pdp>.fv3-rel{margin:32px 0 8px;padding:18px 0 0;}' +
      '#fv3-app .fv3-fbt .fbt-in{gap:18px;}' +
      '#fv3-app .fv3-fbt .fbt-items{flex-wrap:wrap;}' +
      '#fv3-app .fv3-pdp .fv3-rv-rail{grid-auto-columns:220px;}' +
      '#fv3-app .fv3-fbt .fbt-plus{display:none;}#fv3-app .fv3-fbt .fbt-item{flex:1 1 100%;}}';
    document.head.appendChild(st);
  }

  /* Our observer is DISCONNECTED while we mutate so our own writes never
     re-enter, and runs are coalesced rather than firing per mutation record. */
  var obs = null, queued = false, idle = 0, lastKey = '';
  function host() { return document.getElementById('fv3-app') || document.body; }
  function connect() {
    if (!obs) obs = new MutationObserver(schedule);
    obs.observe(host(), { childList: true, subtree: true });
  }
  function guarded() {
    var key = location.pathname + location.hash + '|' + ((window.FV3_CONFIG || {}).pdpSku || '');
    if (key !== lastKey) { lastKey = key; idle = 0; }
    /* Idle accounting is gated on IDX: passes before the catalog index resolves
       necessarily change nothing, and the app's boot churn runs far more than
       30 of them - counting those retired the observer before the module could
       build anything. No give-up counter may run while the module is still
       incapable of work. */
    if (IDX && idle > 30) { if (obs) obs.disconnect(); return; }
    if (obs) obs.disconnect();
    var changed = false;
    DBG.passes++;
    try { changed = run(); } catch (e) { DBG.err = 'run: ' + (e && e.message || e); } finally { connect(); }
    if (changed) idle = 0; else if (IDX) idle++;
  }
  function schedule() {
    if (queued) return;
    queued = true;
    /* setTimeout, NOT requestAnimationFrame. rAF does not fire while the tab
       is hidden or backgrounded, so a PDP opened in a background tab left
       `queued` stuck true forever and the module never ran again. */
    setTimeout(function () { queued = false; guarded(); }, 16);
  }
  function boot() { guarded(); connect(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  window.addEventListener('hashchange', schedule);
})();
